<img class="plc-icon__img" [src]="src" [class]="imgClass" />
